import { render, staticRenderFns } from "./LessonClassUpload.vue?vue&type=template&id=0c5ea723&"
import script from "./LessonClassUpload.vue?vue&type=script&lang=ts&"
export * from "./LessonClassUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports